export const LIFESTYLE_YEARLY_AMOUNT_LIMIT = {
  min: 0,
  max: 9999,
};
